// buildManualEvent — pure assembly of a manually added event object.
//
// Extracted verbatim from `EditTripModal.js` (the `newEvent` object built inside
// `handleAddManualEvent`) as part of the behavior-preserving refactor
// (issue #240). The new event is `{ [config.idKey]: id, ...eventData, status:
// 'Confirmed' }`: the generated id is placed under the config's id field, the
// caller-supplied `eventData` is spread over it (so any `idKey`/`status` present
// in `eventData` overrides, exactly as the source spread order dictated), and
// `status` is finally forced to `'Confirmed'`.
//
// Totality preserved exactly: the source built `newEvent` only after `config` was
// confirmed truthy (its `if (!config)` early-return ran first), so this builder
// assumes a defined `config` and adds no extra guard — a missing `config` throws
// on `config.idKey` just as the source path could not reach with one. The id is
// injected (see `generateEventId`) to keep this builder deterministic.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Builds the normalized event object for a manually added event.
 *
 * @param {{ idKey: string }} config - The event type config (provides `idKey`).
 * @param {Object} eventData - The form-supplied event fields.
 * @param {string} id - The generated id for the new event.
 * @returns {Object} The new event `{ [config.idKey]: id, ...eventData, status: 'Confirmed' }`.
 */
export function buildManualEvent(config, eventData, id) {
  return {
    [config.idKey]: id,
    ...eventData,
    status: 'Confirmed'
  };
}

export default buildManualEvent;
